import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { CreateProgramComponent } from '../../shared/create-program/create-program.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ContractSelectorStateService } from '../../shared/contract-selector-state-service/contract-selector-state.service';
import { Program } from '../../shared/shared.types';
import { DialogService } from '../../shared/dialog-service/dialog.service';
import {SidenavService} from '../../shared/sidenav/sidenav.service';


@Component({
  selector: 'app-program-view',
  templateUrl: './program-view.component.html',
  styleUrls: ['./program-view.component.scss']
})
export class ProgramViewComponent implements OnInit {

  constructor(
    private activatedRoute: ActivatedRoute,
    private contractSelectorState: ContractSelectorStateService,
    private dialog: MatDialog,
    private router: Router,
    private sidenav: SidenavService,
    private ourDialogSrv: DialogService) { }

  programs: Program[] = [];
  cedantId  = 0;
  programId = 0;
  flyoutTitle = 'Title';

  ngOnInit() {
    this.activatedRoute.data.subscribe((data: { cedantId: string }) => {
      this.cedantId   = Number.parseInt(data.cedantId,  10);
      this.contractSelectorState.setCurrentCedanById   (this.cedantId);
    });
    this.activatedRoute.paramMap.subscribe( paramMap => {
      this.programId = Number.parseInt(paramMap.get('programId'), 10);
      this.contractSelectorState.setCurrentProgramBytId(this.programId);
      this.contractSelectorState.setProgramActive();
    });
  }

  onCreateProgram() {
    const config = new MatDialogConfig();
    config.data = { title: 'Program' };
    config.minHeight = '400px';
    config.width = '640px';
    config.panelClass = 'dialog-container-wizard';

    const dialogRef = this.dialog.open(CreateProgramComponent, config);

    dialogRef.afterClosed().subscribe(result => {
      if (result.isOk) {
        this.programs.push(new Program(0, 'Program 1'));
      }
    });
  }


  onInfo() {
    this.flyoutTitle = 'Details';
    //this.sidenav.open();
  }

  onUsers() {
    this.flyoutTitle = 'Team';
    //this.sidenav.open();
  }

  onNotes() {
    this.flyoutTitle = 'Notes';
    //this.sidenav.open();
  }

  onAddContract() {
    this.ourDialogSrv.openCreateContract().afterClosed().subscribe( () => {
      this.router.navigate(['/cedant/0/program/0/contract/0/dashboard']);
    });
  }


}
